module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C204"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_vm._v("ABBREVIATIONS FOR HUME’S WORKS")])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('table', [_c('tbody', [_c('tr', {
    staticClass: "Row_Style1"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("D")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Dialogues Concerning Natural Religion")]), _vm._v(", ed. Norman Kemp Smith. Indianapolis: Bobbs-Merrill, 1947.")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("E")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("Essays Moral, Political, and Literary")]), _vm._v(", ed. Eugene Miller. Indianapolis: Liberty Classics, 1985.")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("EU/EM")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("David Hume’s Enquiries Concerning Human Understanding [EU] and Concerning the Principles of Morals [EM]")]), _vm._v(", ed. L. A. Selby-Bigge. 3d ed. revised, ed. P. H. Nidditch. Oxford: Clarendon Press, 1975.")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("H")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("The History of England, From the Invasion of Julius Caesar to The Revolution in 1688")]), _vm._v(", with the author’s last corrections and improvements. 6 vols. Indianapolis: Liberty Classics, 1983.")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("HEM")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("“Hume’s Early Memoranda, 1729–40: The Complete Text,” "), _c('em', [_vm._v("Journal of the History of Ideas")]), _vm._v(" 9 (1948): 492–518.")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("L")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("The Letters of David Hume")]), _vm._v(", ed. J. Y. T. Greig. 2 vols. Oxford: Clarendon Press, 1969.")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("LG")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("A Letter from a Gentleman to His Friend in Edinburgh")]), _vm._v(", ed. Ernest C. Mossner and John V. Price. Edinburgh: University of Edinburgh Press, 1967.")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("NHL")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("New Letters of David Hume")]), _vm._v(", ed. R. Klibansky and E. C. Mossner. Oxford: Clarendon Press, 1954.")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("NHR")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("The Natural History of Religion and Dialogues Concerning Natural Religion")]), _vm._v(", ed. A. Wayne Colver and John Vladimir Price. Oxford: Clarendon Press, 1976.")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style1"
  }, [_c('em', [_vm._v("T")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style2"
  }, [_c('em', [_vm._v("A Treatise of Human Nature")]), _vm._v(", ed. L. A. Selby-Bigge. 2d edition with text revised and variant readings by P. H. Nidditch. Oxford: Clarendon Press, 1978.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b593f736","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/07_List_of_Abbreviations.vue
// module id = 75
// module chunks = 0